import { render, staticRenderFns } from "./CalculoPonto.vue?vue&type=template&id=217f1919&"
import script from "./CalculoPonto.vue?vue&type=script&lang=js&"
export * from "./CalculoPonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports